import { combineReducers } from 'redux';

import { types } from './actions';

const initialNotesState = {
  error: false,
  errorMessage: null,
  isSaving: false,
  savedSuccessful: false,
};

const createNotesReducer =
  ({ request, success, error, reset }) =>
  (state = initialNotesState, action) => {
    const { type, payload } = action;
    switch (type) {
      case request:
        return {
          ...state,
          error: false,
          errorMessage: null,
          isSaving: true,
          savedSuccessful: false,
        };
      case success:
        return {
          ...state,
          isSaving: false,
          savedSuccessful: true,
        };
      case error:
        return {
          ...state,
          error: true,
          errorMessage: payload.message,
          isSaving: false,
        };
      case reset:
        return initialNotesState;
      default:
        return state;
    }
  };

export default combineReducers({
  accountNotes: createNotesReducer({
    request: types.ACCOUNT_NOTES_REQUEST,
    success: types.ACCOUNT_NOTES_SUCCESS,
    error: types.ACCOUNT_NOTES_ERROR,
    reset: types.RESET_ACCOUNT_NOTES,
  }),
  contactNotes: createNotesReducer({
    request: types.CONTACT_NOTES_REQUEST,
    success: types.CONTACT_NOTES_SUCCESS,
    error: types.CONTACT_NOTES_ERROR,
    reset: types.RESET_CONTACT_NOTES,
  }),
});

export const getScope = (state) => state.modules.quotes.contactAndAccountNotes;

export const getAccountNotesState = (state) => getScope(state).accountNotes;

export const getContactNotesState = (state) => getScope(state).contactNotes;
